import { ScrollToApplyButton } from 'components/ApplyButton/ScrollToApplyButton';
import { DesktopOnly } from 'components/Breakpoint/DesktopOnly';
import { SaveListingButton } from 'components/SaveButton/SaveListingButton';
import { ShareListingButton } from 'components/ShareListingButton/ShareListingButton';
import type { ApiInternship } from 'modules/listing/api/internship/types/ApiInternship';
import { ListingActionsDropdown } from 'modules/listing/components/ListingActionsDropdown/ListingActionsDropdown';
import { ListingViewActionButtons } from 'modules/listing/components/ListingView/ActionButtons/ListingViewActionButtons';
import type { OrgDashboardApiInternship } from 'modules/orgDashboard/api/listing/types/OrgDashboardApiInternship';

type Props = {
  internship: ApiInternship | OrgDashboardApiInternship;
  applied: boolean;

  // Save internship
  internshipSaved: boolean;
  onSaveInternship: () => Promise<void>;
  onUnsaveInternship: () => Promise<void>;

  // Save Org
  orgSaved: boolean;
  shouldShowSaveOrgTooltip: boolean;
  onSaveOrg: () => Promise<void>;
  onUnsaveOrg: () => Promise<void>;
  onDismissSaveOrgTooltip: () => void;
};

export function ViewInternshipActionButtons({
  internship,
  applied,
  internshipSaved,
  onSaveInternship,
  onUnsaveInternship,
  orgSaved,
  shouldShowSaveOrgTooltip,
  onSaveOrg,
  onUnsaveOrg,
  onDismissSaveOrgTooltip,
}: Props) {
  const { id, hasAts, url, org } = internship;

  return (
    <ListingViewActionButtons>
      <ScrollToApplyButton
        atsIsEnabled={hasAts}
        applied={applied}
        size="medium"
      />

      <SaveListingButton
        listingType="INTERNSHIP"
        listingSaved={internshipSaved}
        onSaveListing={onSaveInternship}
        onUnsaveListing={onUnsaveInternship}
        orgDetails={{
          onSaveOrg,
          onDismissSaveOrgTooltip,
          shouldShowSaveOrgTooltip,
        }}
      />

      <DesktopOnly>
        <ShareListingButton
          disabled={!url}
          listingId={id}
          listingType="INTERNSHIP"
          listingUrl={url}
        />
      </DesktopOnly>

      <ListingActionsDropdown
        listingId={id}
        listingType="INTERNSHIP"
        listingUrl={url}
        orgDetails={
          org
            ? {
                orgId: org.id,
                orgName: org.name,
                orgType: org.orgType,
                orgSaved,
                onSaveOrg,
                onUnsaveOrg,
              }
            : null
        }
        markAsAppliedButton={null}
      />
    </ListingViewActionButtons>
  );
}
